// extracted by mini-css-extract-plugin
export default {"titleUA":"edit-relations-UA-styles_titleUA__2sfkO"};